import type { ReactNode } from 'react'

export type SkillListRowProps = {
  name: string
  updatedAt: string | null
  author: 'You' | 'Paxton'
  actions: ReactNode
  onOpen: () => void
}

export default function SkillListRow({ name, updatedAt, author, actions, onOpen }: SkillListRowProps) {
  return (
    <div className="relative grid grid-cols-[minmax(0,1fr)_32px] items-center gap-3 border-b border-brand-neutral-200 px-4 py-3 last:border-b-0 hover:bg-brand-neutral-100 sm:grid-cols-[minmax(0,1fr)_112px_72px_32px] sm:px-6 md:grid-cols-[minmax(0,1fr)_144px_120px_32px]">
      <button
        type="button"
        className="min-w-0 truncate text-left text-sm text-brand-neutral-950 after:absolute after:inset-0 focus-visible:outline-hidden focus-visible:after:ring-2 focus-visible:after:ring-brand-500 focus-visible:after:ring-inset"
        onClick={onOpen}
      >
        {name}
      </button>
      <span className="hidden text-sm text-brand-neutral-950 sm:block">
        {updatedAt ? new Date(updatedAt).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }) : '—'}
      </span>
      <span className="hidden truncate text-sm text-brand-neutral-950 sm:block">{author}</span>
      <div className="relative flex justify-end">{actions}</div>
    </div>
  )
}
